import React from 'react';
import PropTypes from 'prop-types';

const RadioButtonSelected = ({
                 fill, height, width, ...style
               }) => (
  <svg version="1.1" id="Layer_1" x="0px" height={height} width={width}
       y="0px" viewBox="0 0 20.8 20.8" style={{enableBackground: 'new 0 0 20.8 20.8', style}}>
    <path id="Icon" style={{fill: fill}} d="M10.4,5.4c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5C15.4,7.7,13.2,5.4,10.4,5.4
	C10.5,5.4,10.4,5.4,10.4,5.4z M10.4,0.4c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10C20.4,4.9,15.9,0.4,10.4,0.4z M10.4,18.4
	c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8C18.4,14.8,14.8,18.4,10.4,18.4z"/>
  </svg>

);

RadioButtonSelected.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
};

RadioButtonSelected.defaultProps = {
  fill: '#F04D4D',
  height: '20px',
  width: '20px',
  style: {width: '20px', height: '20px'},
};

export default RadioButtonSelected;



// WEBPACK FOOTER //
// ./src/components/RadioButtonSelected.jsx